export default __webpack_public_path__ + "static/media/icon_csv.9937e234.svg";